"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMatchingSavedAddress = exports.areAddressesEquivalent = exports.EmptyAddress = void 0;
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const lodash_1 = require("lodash");
exports.EmptyAddress = {
    fullName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateProvinceRegion: '',
    postalCode: '',
    country: 'US',
    phonePrimary: { phoneNumber: '' }
};
const defaultAddressFieldsToCompare = [
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'fullName',
    'city',
    'stateProvinceRegion',
    'country',
    'postalCode'
];
const areAddressesEquivalent = (address1, address2, addressFieldsToCompare = defaultAddressFieldsToCompare) => {
    if (address1 === address2) {
        return true;
    }
    if ((0, lodash_1.isNil)(address1) || (0, lodash_1.isNil)(address2)) {
        return false;
    }
    if ((0, lodash_1.isEmpty)(addressFieldsToCompare)) {
        return false;
    }
    for (let i = 0; i < addressFieldsToCompare.length; i++) {
        const field = addressFieldsToCompare[i];
        const val1 = address1[field] || '';
        const val2 = address2[field] || '';
        if (val1 !== val2) {
            return false;
        }
    }
    return true;
};
exports.areAddressesEquivalent = areAddressesEquivalent;
const findMatchingSavedAddress = (savedAddresses, address) => {
    return (0, lodash_1.find)(savedAddresses, (saved) => (0, exports.areAddressesEquivalent)(saved, address));
};
exports.findMatchingSavedAddress = findMatchingSavedAddress;
//# sourceMappingURL=address-utils.js.map